import 'reflect-metadata';
import { Expose, plainToInstance, instanceToPlain } from 'class-transformer';

export class DemoInfo {
  @Expose({ name: 'contact_email' })
  contactEmail: string;

  @Expose({ name: 'contact_phone' })
  contactPhone: string;

  @Expose({ name: 'contact_skype' })
  contactSkype: string;

  @Expose({ name: 'user_allowed' })
  isUserAllowed: boolean;

  @Expose({ name: 'messenger_name' })
  messengerName?: string;

  @Expose({ name: 'privacy_policy_url' })
  privacyPolicyUrl?: string;

  constructor(
    contactEmail: string,
    contactPhone: string,
    contactSkype: string,
    isUserAllowed: boolean,
    messengerName?: string,
    privacyPolicyUrl?: string
  ) {
    this.contactEmail = contactEmail;
    this.contactPhone = contactPhone;
    this.contactSkype = contactSkype;
    this.isUserAllowed = isUserAllowed;
    this.messengerName = messengerName;
    this.privacyPolicyUrl = privacyPolicyUrl;
  }

  static fromJson(json: Record<string, any>): DemoInfo {
    return plainToInstance(DemoInfo, json);
  }

  toJson(): any {
    return instanceToPlain(this);
  }

  copyWith({
    contactEmail,
    contactPhone,
    contactSkype,
    isUserAllowed,
    messengerName,
    privacyPolicyUrl,
  }: Partial<DemoInfo>): DemoInfo {
    return new DemoInfo(
      contactEmail ?? this.contactEmail,
      contactPhone ?? this.contactPhone,
      contactSkype ?? this.contactSkype,
      isUserAllowed ?? this.isUserAllowed,
      messengerName ?? this.messengerName,
      privacyPolicyUrl ?? this.privacyPolicyUrl
    );
  }
}
